var render, staticRenderFns
import script from "./signup-form.vue?vue&type=script&lang=js&"
export * from "./signup-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('747a2fc4')) {
      api.createRecord('747a2fc4', component.options)
    } else {
      api.reload('747a2fc4', component.options)
    }
    
  }
}
component.options.__file = "frontend/static/js/components/signup-form.vue"
export default component.exports